export default {"src":"/_next/static/media/privacy-policy-development.0f9961dd.svg","height":464,"width":522,"blurWidth":0,"blurHeight":0};